(function() {
'use strict';

angular
    .module('TR')
    .service('reviewService', reviewService);

function reviewService($rootScope, $http, $q, arrayUtil, authService, $location) {
    const domain = TRPCONFIG.Domain;
    const url = '/api2/users/reviews/';
    const limit = 1750; //borrowed this limit from the jquery plugin
    const suggestedPageSize = 10; // PageSize should probably be passed as an argument to getReviews()
    const likeTypes = {
        organic: 1,
        postSubmission: 2
    };
    let apiKey;
    let reviewsCache = {};

    const service = {
        getUrl,
        getRatingCategories,
        getStatements,
        getOriginalText,
        getReviews,
        getReviewSnippets,
        setTranslation,
        setSnippetTranslation,
        setTranslationKey,
        getReviewDetails,
        getReviewDetailsUsingToken,
        likeReview: {
            organic: organicLike,
            postSubmission: postSubmissionLike
        },
        reviewStatus: {
            CannotLeaveReview: 0,
            CanLeaveReview: 1,
            HasLeftReview: 2
        }
    };

    $rootScope.$on('auth:signout', function() {
        _clearCache();
        //remove liked review index from url so refresh won't cause redirection to sign in page
        if ($location.$$search.lr) {
            delete $location.$$search.lr;
            $location.$$compose();
        }
    });
    $rootScope.$on('auth:signin', _clearCache);

    function getUrl() {
        return url;
    }

    function getRatingCategories(cultureCode) {
        return $http.post(`${url}getratingcategories`, {
            CultureCode: cultureCode
        });
    }

    function getStatements(cultureCode) {
        return $http.post(`${url}getstatements`, {
            CultureCode: cultureCode
        });
    }

    function getOriginalText(reviewId) {
        return $http.post(`${url}getoriginaltext`, {
            ReviewId: reviewId
        }, { ignoreErrors: true }).then(function(res) {
            res.data.Comments = htmlifyLineBreaks(res.data.Comments);
            res.data.TopTip = htmlifyLineBreaks(res.data.TopTip);
            return res.data;
        });
    }

    function setTranslationKey(key) {
        apiKey = key;
    }

    function _truncate(val) {
        if (val != null && val.length > limit) {
            return val.substring(0, limit);
        }
        return val;
    }

    function _translate(text, source, target) {
        const googleUrl = 'https://www.googleapis.com/language/translate/v2?';
        text = $.trim(text);

        if (text === '') {
            return $q.when(null);
        }

        return $http.jsonp(googleUrl, {
            params: {
                key: apiKey,
                source,
                target,
                q: text,
                callback: 'JSON_CALLBACK'
            }
        });
    }

    function getTranslatedText(resp) {
        if (resp != null && resp.data != null && resp.data.data != null && resp.data.data.translations && resp.data.data.translations.length > 0) {
            return resp.data.data.translations[0].translatedText;
        }
        return '';
    }

    function setTranslation(review) {
        // truncation is somewhat lame. Can we split the string up into a number of batches possibly, but it would
        // be hard to do that without messing with the meaning of the text. Perhaps breaking it into sentences?
        const promises = [];
        const source = review.CultureCode;
        const target = domain.CultureCode.substring(0, 2);

        promises.push(_translate(_truncate(review.Comments), source, target));
        promises.push(_translate(_truncate(review.TopTip), source, target));

        return $q
            .all(promises)
            .then(function(responses) {
                const result = {
                    Comments: getTranslatedText(responses[0]),
                    TopTip: getTranslatedText(responses[1])
                };

                return $http.post(`${url}settranslation`, {
                    ReviewId: review.ReviewId,
                    Comments: result.Comments,
                    TopTip: result.TopTip,
                    CultureCode: target
                }, { ignoreErrors: true })
                    .then(function() {
                        return result;
                    });
            });
    }

    function setSnippetTranslation(snippet) {
        // Same truncation comment as above, but probably has no impact on a snippet.
        const promises = [];
        const source = snippet.CultureCode;
        const target = domain.CultureCode.substring(0, 2);

        promises.push(_translate(_truncate(snippet.Comments), source, target));

        return $q
            .all(promises)
            .then(function(responses) {
                const result = {
                    Comments: responses[0] != null ? responses[0].data.data.translations[0].translatedText : ''
                };

                return $http.post(`${url}setsnippettranslation`, {
                    ReviewId: snippet.ReviewId,
                    Comments: result.Comments,
                    CultureCode: target
                }, { ignoreErrors: true })
                    .then(function() {
                        return result;
                    });
            });
    }

    function htmlifyLineBreaks(text) {
        return text ? text.replace(/\\n/g, '<br/>').replace(/\n/g, '<br/>') : text;
    }

    function getReviews(hotel, page) {
        const pageSize = suggestedPageSize;

        if (reviewsCache[hotel.Id] == null) {
            reviewsCache[hotel.Id] = {
                total: hotel.CustomerReviewCount,
                page: 1,
                reviews: {}
            };
        }
        const cache = reviewsCache[hotel.Id];
        const d = $q.defer();
        cache.page = page;

        //is this a page that exists?
        if (((page) * pageSize) > cache.total) {
            throw new Error(`there is no page ${page}`);
        }

        function resolve() {
            const remaining = (cache.total - (page + 1) * pageSize);
            d.resolve({
                reviews: cache.reviews[page],
                moreReviews: (remaining > pageSize) ? pageSize : Math.max(remaining, 0),
                page
            });
        }

        //have we got the data for this page
        if (cache.reviews[page] != null) {
            resolve();
        } else {
            $http.post(`${url}getpage`, {
                EstabId: hotel.Id,
                CultureCode: domain.CultureCode,
                CountryCode: domain.CountryCode,
                Paging: {
                    PageIndex: page,
                    PageSize: pageSize
                },
                SortCriterion: 0,
                FilterCriteria: {
                    ExcludeEmptyComments: true
                }
            }, { ignoreErrors: true }).then(function(res) {
                cache.reviews[page] = arrayUtil.map(res.data.Reviews, function(review) {
                    review.Comments = htmlifyLineBreaks(review.Comments);
                    review.TopTip = htmlifyLineBreaks(review.TopTip);
                    return review;
                });
                resolve();
            }, function() {
                d.reject();
            });
        }

        return d.promise;
    }

    function getReviewSnippets(hotel, pageIndex, pageSize) {
        return $http.post(`${url}getsnippetpage`, {
            EstabId: hotel.Id,
            CultureCode: domain.CultureCode,
            Paging: {
                PageIndex: pageIndex,
                PageSize: pageSize
            }
        });
    }

    function organicLike(reviewId, like) {
        return _likeReview(reviewId, like, likeTypes.organic);
    }

    function postSubmissionLike(reviewId, like) {
        return _likeReview(reviewId, like, likeTypes.postSubmission);
    }

    function _likeReview(reviewId, like, reviewLikeType) {
        return $http.post(`${url}like`, {
            ReviewId: reviewId,
            Like: like,
            ReviewLikeType: reviewLikeType,
            ApplicationType: TRPCONFIG.ApplicationType
        }, {
            customErrCallback() {
                    return true; //make sure that the default error handling does not occur
                } //Note that we will stay in the error branch

        }).then(null, _errorLike);

        function _errorLike(resp) {
            if (resp.status === 401) {
                _signIn();
            }
        }

        function _signIn() {
            const url = `${$location.path()}?pd=rv&lr=${reviewId}`;
            authService.bufferRoute(url);
            $location.url(`signin?cb=${encodeURIComponent(url)}`);
        }
    }

    function _clearCache() {
        reviewsCache = {};
    }

    function getReviewDetailsUsingToken(bookingId, token, userId) {
        return $http.post(
            `${url}user/reviewdetailstoken`
            , { BookingId: bookingId, VerificationToken: token, UserId: userId, CultureCode: domain.CultureCode }
        ).then(
            res => res.data
            , err => _processGetReviewError(err.status)
        );
    }

    function getReviewDetails(bookingId) {
        return $http.post(
            `${url}user/reviewdetails`
            , { BookingId: bookingId, CultureCode: domain.CultureCode }
        ).then(res => res.data
                , err => _processGetReviewError(err.status)
        );
    }

    function _processGetReviewError(errCode) {
        //we can have a number of different states but just return the correct enum value
        let detail = {
            BookingRef: null,
            CheckInDate: null,
            EstabId: null,
            LeadContact: null,
            ReviewStatus: service.reviewStatus.CannotLeaveReview
        };

        if (errCode === 401) {
            detail.Status = service.reviewStatus.CannotLeaveReview;
        }

        return detail;
    }

    return service;
}
})();
